// Cadastro manual de licença regulatória (Feature C).

import { lex } from './lex-client.js';
import { FILIAIS_OPTIONS } from './cnpjs-icaro.js';

const TIPOS = [
  { v: 'RNTRC',     label: 'RNTRC (ANTT)' },
  { v: 'AFE',       label: 'AFE (ANVISA)' },
  { v: 'AVCB',      label: 'AVCB (Bombeiros)' },
  { v: 'AET',       label: 'AET (Trânsito)' },
  { v: 'LO',        label: 'Licença de Operação (LO)' },
  { v: 'LP',        label: 'Licença Prévia (LP)' },
  { v: 'LI',        label: 'Licença de Instalação (LI)' },
  { v: 'CTF-IBAMA', label: 'CTF (IBAMA)' },
  { v: 'ALVARA',    label: 'Alvará de Funcionamento' },
  { v: 'OUTRO',     label: 'Outro' },
];

const ORGAOS = [
  'ANTT', 'ANVISA', 'ANAC', 'IBAMA', 'Bombeiros', 'Prefeitura',
  'IMA-SC', 'CETESB-SP', 'IAT-PR', 'INEA-RJ', 'FEPAM-RS', 'FEAM-MG',
  'IEMA-ES', 'DETRAN', 'Outro',
];

const ESFERAS = [
  { v: 'federal',   label: 'Federal' },
  { v: 'estadual',  label: 'Estadual' },
  { v: 'municipal', label: 'Municipal' },
];

export function renderFormLicenca({ onCancel, onSubmit }) {
  const today = new Date().toISOString().slice(0, 10);
  const cnpjEPorFilial = Object.fromEntries(
    FILIAIS_OPTIONS.map(f => [f.filial, f.cnpj])
  );

  const wrap = document.createElement('form');
  wrap.id = 'lex-form-licenca';
  wrap.innerHTML = `
    <div class="lex-form-grid">

      <div class="lex-field">
        <label>Filial <span class="req">*</span></label>
        <select name="filial_codigo" required>
          ${FILIAIS_OPTIONS.map(f => `
            <option value="${f.filial}">${f.filial} — ${f.cidade}/${f.uf}${f.matriz ? ' (matriz)' : ''}</option>
          `).join('')}
        </select>
      </div>

      <div class="lex-field">
        <label>Tipo da licença <span class="req">*</span></label>
        <select name="tipo" required>
          ${TIPOS.map(t => `<option value="${t.v}">${t.label}</option>`).join('')}
        </select>
      </div>

      <div class="lex-field">
        <label>Número</label>
        <input type="text" name="numero" placeholder="ex: 12345678" />
      </div>

      <div class="lex-field">
        <label>Órgão emissor <span class="req">*</span></label>
        <input list="lex-orgaos" name="orgao_emissor" required placeholder="ANTT, ANVISA…" />
        <datalist id="lex-orgaos">
          ${ORGAOS.map(o => `<option value="${o}">`).join('')}
        </datalist>
      </div>

      <div class="lex-field">
        <label>Esfera</label>
        <select name="esfera">
          <option value="">—</option>
          ${ESFERAS.map(e => `<option value="${e.v}">${e.label}</option>`).join('')}
        </select>
      </div>

      <div class="lex-field">
        <label>Validade <span class="req">*</span></label>
        <input type="date" name="data_validade" required min="${today.slice(0,4) - 5}-01-01" />
      </div>

      <div class="lex-field">
        <label>Data de emissão</label>
        <input type="date" name="data_emissao" />
      </div>

      <div class="lex-field">
        <label>Custo de renovação estimado (R$)</label>
        <input type="number" name="custo_renovacao_estimado" step="0.01" min="0" placeholder="850.00" />
      </div>

      <div class="lex-field lex-field--full">
        <label>Responsável (e-mail)</label>
        <input type="email" name="responsavel_email" placeholder="frota@icaroexpress.com" />
        <small class="hint">Recebe os alertas de vencimento (90/60/30/15/7 dias).</small>
      </div>

      <div class="lex-field lex-field--full">
        <label>Observações</label>
        <textarea name="observacoes" rows="2" placeholder="Notas internas sobre esta licença"></textarea>
      </div>

    </div>
  `;

  // Footer com botões
  const foot = document.createElement('div');
  foot.style.cssText = 'display:contents';
  foot.innerHTML = `
    <button type="button" class="lex-btn-secondary" data-act="cancel">Cancelar</button>
    <button type="submit" class="lex-btn" style="width:auto;padding:10px 18px">Cadastrar licença</button>
  `;

  wrap.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(wrap);
    const cnpj = cnpjEPorFilial[fd.get('filial_codigo')];

    const payload = {
      filial_codigo: fd.get('filial_codigo'),
      cnpj_icaro: cnpj,
      tipo: fd.get('tipo'),
      numero: (fd.get('numero') || '').trim() || null,
      orgao_emissor: (fd.get('orgao_emissor') || '').trim(),
      esfera: fd.get('esfera') || null,
      data_emissao: fd.get('data_emissao') || null,
      data_validade: fd.get('data_validade'),
      custo_renovacao_estimado: fd.get('custo_renovacao_estimado')
        ? Number(fd.get('custo_renovacao_estimado')) : null,
      responsavel_email: (fd.get('responsavel_email') || '').trim() || null,
      observacoes: (fd.get('observacoes') || '').trim() || null,
      status: 'ativa',
    };

    const submitBtn = foot.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Salvando…';

    try {
      const { error } = await lex.from('licencas').insert(payload);
      if (error) throw error;
      onSubmit?.(payload);
    } catch (err) {
      alert('Erro ao salvar: ' + (err.message || err));
      submitBtn.disabled = false;
      submitBtn.textContent = 'Cadastrar licença';
    }
  });

  foot.querySelector('[data-act="cancel"]').addEventListener('click', () => onCancel?.());

  return { form: wrap, footer: foot };
}
